import clsx from "clsx";

/**
 * Classes CSS para o container do FormInput
 */
export function getFormInputContainerClasses(className?: string): string {
  return clsx("space-y-1.5", className);
}

/**
 * Classes CSS para o label
 */
export function getFormInputLabelClasses(
  required: boolean = false,
  hasError: boolean = false
): string {
  return clsx(
    "block text-xs font-semibold font-montserrat mb-1",
    {
      "text-raro-gray-700": !hasError,
      "text-red-600": hasError,
    },
    required && "after:content-['*'] after:text-red-500 after:ml-1"
  );
}

/**
 * Classes CSS para o input - AJUSTADO: menor e menos arredondado
 */
export function getFormInputClasses(
  hasError: boolean = false,
  hasIcon: boolean = false
): string {
  return clsx(
    // Classes base - AJUSTADO: padding menor e border radius menor
    "w-full px-3 py-2 font-montserrat rounded-lg border transition-all duration-200",
    "text-sm placeholder:text-raro-gray-400 focus:outline-none focus:ring-1",

    // Padding para ícone - AJUSTADO
    {
      "pl-9": hasIcon,
    },

    // Estados condicionais
    {
      // Estado normal
      "border-raro-gray-300 focus:border-primary-500 focus:ring-primary-500/20":
        !hasError,

      // Estado de erro
      "border-red-500 focus:border-red-500 focus:ring-red-500/20 bg-red-50":
        hasError,
    }
  );
}

/**
 * Classes CSS para o container do ícone - AJUSTADO
 */
export function getIconContainerClasses(): string {
  return clsx(
    "absolute inset-y-0 left-0 pl-2.5",
    "flex items-center pointer-events-none"
  );
}

/**
 * Classes CSS para mensagem de erro - AJUSTADO
 */
export function getErrorMessageClasses(): string {
  return clsx("text-xs text-red-600 font-montserrat mt-1");
}

/**
 * Classes CSS para texto de ajuda - AJUSTADO
 */
export function getHelperTextClasses(): string {
  return clsx("text-xs text-raro-gray-500 font-montserrat mt-1");
}
